import { GetSummaryResponseDTO } from '@/api/section/DTOs';
import { adaptDecimalValueToPercentage } from '../utilities';

export const adaptGetSectionSummaryResponseToApplicationSummary = (
  sectionSummaryResponse: GetSummaryResponseDTO,
): {
  completedPercentage: number;
  completedSections: number;
} => {
  return {
    completedPercentage: adaptDecimalValueToPercentage(
      sectionSummaryResponse.application.applicationCompletedPercentage,
    ),
    completedSections:
      sectionSummaryResponse.application.applicationSectionsCompleted,
  };
};
